/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */

import getQueryParameters from './urlparser';
import NumberFormatter from '../cldr/number-formatter';

const formatters = {};

const displayLabelBlock = (formatterId, displayBlock, min, max) => {
  if (formatters[formatterId] === undefined) {
    displayBlock.text(
      displayBlock.text().replace(
        /([^\d]*)(?:[\d\s.,]+)([^\d]+)(?:[\d\s.,]+)(.*)/,
        `$1${min}$2${max}$3`,
      ),
    );
  } else {
    displayBlock.text(
      `${formatters[formatterId].format(min)} - ${formatters[formatterId].format(max)}`,
    );
  }
};

/**
 * Refresh facets sliders
 */
const refreshSliders = ($context) => {
  const $container = $context || $(document);
  console.log('refreshSliders called');
  console.log('Number of .faceted-slider elements:', $container.find('.faceted-slider').length);
  
  $container.find('.faceted-slider').each(function initializeSliders() {
    const $el = $(this);
    const sliderId = $el.data('slider-id');
    const values = $el.data('slider-values');
    const specifications = $el.data('slider-specifications');

    console.log('Processing slider:', sliderId);
    console.log('Slider element:', $el.attr('id'));
    console.log('Slider values:', values);
    console.log('Slider min:', $el.data('slider-min'), 'max:', $el.data('slider-max'));

    if (specifications !== null && specifications !== undefined) {
      formatters[sliderId] = NumberFormatter.build(specifications);
    }

    displayLabelBlock(
      sliderId,
      $(`#facet_label_${sliderId}`),
      values === null ? $el.data('slider-min') : parseInt(values[0], 10),
      values === null ? $el.data('slider-max') : parseInt(values[1], 10),
    );

    const $slider = $(`#slider-range_${sliderId}`);
    const hasSliderClass = $slider.hasClass('ui-slider');
    const hasSliderData = $slider.data('ui-slider') !== undefined;
    
    console.log('Slider element found:', $slider.length, 'hasClass ui-slider:', hasSliderClass, 'hasData:', hasSliderData);

    const sliderValues = [
      values === null ? $el.data('slider-min') : parseInt(values[0], 10),
      values === null ? $el.data('slider-max') : parseInt(values[1], 10),
    ];

    // If slider already exists with actual jQuery UI data, check if values need updating
    if ($slider.length && hasSliderClass && hasSliderData) {
      const currentValues = $slider.slider('values');
      // Only update if values are different (not just min/max reset)
      const needsUpdate = values !== null && (
        currentValues[0] !== sliderValues[0] || 
        currentValues[1] !== sliderValues[1]
      );
      
      if (needsUpdate) {
        console.log('Slider already exists, updating values:', sliderValues);
        $slider.slider('option', 'values', sliderValues);
        displayLabelBlock(
          sliderId,
          $(`#facet_label_${sliderId}`),
          sliderValues[0],
          sliderValues[1],
        );
        console.log('Slider values updated for:', sliderId);
      } else {
        console.log('Slider already exists with correct values, skipping update');
      }
      return;
    }

    console.log('Initializing slider with values:', sliderValues);

    $slider.slider({
      range: true,
      min: $el.data('slider-min'),
      max: $el.data('slider-max'),
      values: [
        values === null ? $el.data('slider-min') : values[0],
        values === null ? $el.data('slider-max') : values[1],
      ],
      create(event, ui) {
        console.log('Slider created:', sliderId);
        console.log('Slider element:', $slider[0]);
        console.log('Handles:', $slider.find('.ui-slider-handle').length);
      },
      start(event, ui) {
        console.log('Slider start event:', ui.values);
      },
      stop(event, ui) {
        console.log('Slider stop event:', ui.values);
        
        // Check if we're updating the URL (from drawer.js)
        if (window.isUpdatingUrl) {
          console.log('Skipping slider stop event - URL is being updated');
          return;
        }
        
        const nextEncodedFacetsURL = $el.data('slider-encoded-url');
        const urlsSplitted = nextEncodedFacetsURL.split('?');
        let queryParams = [];

        // Retrieve parameters if exists
        if (urlsSplitted.length > 1) {
          queryParams = getQueryParameters(urlsSplitted[1]);
        }

        let found = false;
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            found = true;
          }
        });

        if (!found) {
          queryParams.push({name: 'q', value: ''});
        }

        // Update query parameter
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            // eslint-disable-next-line
            query.value += [
              query.value.length > 0 ? '/' : '',
              $el.data('slider-label'),
              '-',
              $el.data('slider-unit'),
              '-',
              ui.values[0],
              '-',
              ui.values[1],
            ].join('');
          }
        });

        const requestUrl = [
          urlsSplitted[0],
          '?',
          $.param(queryParams),
        ].join('');

        prestashop.emit(
          'updateFacets',
          requestUrl,
        );
      },
      slide(event, ui) {
        console.log('Slider slide event:', ui.values);
        displayLabelBlock(
          sliderId,
          $(`#facet_label_${sliderId}`),
          ui.values[0],
          ui.values[1],
        );
      },
    });
    
    console.log('Slider initialized for:', sliderId);
  });
};

export default refreshSliders;
